.ba{padding:0.5rem;}